var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("keep-alive", [
    _c("div", { ref: "skyFormWrapper", attrs: { id: _vm.div_id } }, [
      _c("button", { attrs: { id: _vm.btn_id } }, [
        _vm._v(_vm._s(_vm._f("translate")("formElementLabelSubmit"))),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }